import React from 'react';

import Money from 'components/Money';

// Owed is similiar to balance, except it's inverted.
// So instead of -1000, if the customer shows owes us 1000, we show OWED 1000.
// If the balance is 0, or positive (we owe the customer money), we show `-` in the owed column

const Owed = ({amount}) => {
  return amount >= 0 ? <div>-</div> : <Money amount={-1 * amount} />;
};

export default Owed;
